module.exports = __webpack_public_path__ + "static/img/biaopai_bg.47fe7ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/biaopai_bg.png
// module id = PXi+
// module chunks = 2